import { type RefObject, useEffect } from 'react';

export const useOutsideClick = (ref: RefObject<HTMLElement | null>, onClickOut: () => void, deps = []) => {
  useEffect(() => {
    const onClick = ({ target }: MouseEvent) => {
      if (!ref.current?.contains(target as Node)) {
        onClickOut();
      }
    };

    document.addEventListener('click', onClick);

    return () => {
      document.removeEventListener('click', onClick);
    };
  }, deps);
};
